"use strict";

exports.__esModule = true;
exports.SORTING_BY_MAP = exports.SERVICE_FEE_RULES_PATTERNS = exports.SEARCH_TYPES = exports.SEARCH_BOX_STATE_PROPS = exports.SEARCH_BOX_ERRORS = exports.SEARCH_BOX_CONSTANTS = exports.SAUDI_AIRLINE_CODE = exports.ROUTE_REGEX = exports.ROUTE_AIRLINE_REGEX = exports.REFUND_METHODS = exports.QUERY_DATE_REGEX = exports.PRICING_KEY_SEPARATOR = exports.PRICING_DATE_RANGE = exports.PERPIECEWEIGHTFLAG = exports.PAX_TYPES = exports.OUTBOUND = exports.OPEN_TICKETING_TYPES = exports.ONLINECHECKIN = exports.NEXUS_SESSION_ID_HEADER = exports.MULTI_REWARDS_ITEMS = exports.MIN_PAX_COUNT = exports.MIN_GROUP_LENGTH = exports.MAX_SEAT_COUNT = exports.LOCATION_TYPES = exports.LEG_IDS_SEPARATOR = exports.INSURANCE = exports.INFANT_MAX_AGE = exports.INBOUND = exports.ID_TYPES = exports.HAJJ_UMRAH_FLIGHTS = exports.HAJJ_UMRAH_AIRPORTS = exports.GROUP_VALUES_SEPARATOR = exports.FREQUENT_FLYER_SEPARATOR = exports.FREQUENT_FLYER_GROUP_MAP = exports.FREQUENT_FLYERS_MAP = exports.FLYNAS_CODE = exports.FLYADEAL_CODE = exports.FLIGHT_SEARCH_META = exports.FLIGHT_PROPERTY_WEIGHT_MAP = exports.FLIGHT_DIRECTIONS = exports.FLEX_DATE_REGEX = exports.FLEX_AIRLINES = exports.FILTER_PARAM_RANGE_SEPARATOR = exports.FILTER_PARAM_LEG_SEPARATOR = exports.FILTER_PARAM_LEG_ITEM_SEPARATOR = exports.FILTER_PARAM_ALL_ITEM = exports.FILTER_PARAM_ALL_AIRPORTS = exports.FILTER_PARAM_AIRPORT_SEPARATOR = exports.FILTER_PARAMS_MAP = exports.FARE_RULES_TYPE_MAP = exports.FARE_RULES_STATUS_MAP = exports.FARE_RULES_PAX_CODE = exports.EXTRA_BAGGAGE_FULL_TRIP = exports.ENDPOINTS = exports.DURATION_UNIT = exports.DOMESTIC_ID_SEPARATOR = exports.DOMESTIC_ALLOWED_HOUR_DIFFERENCE = exports.DOMESTIC_AIRPORTS = exports.DEFAULT_SORT_KEY = exports.DEFAULT_SORTING_LOGIC = exports.DEFAULT_GROUP_PATHS = exports.DEFAULT_GROUP_KEYS_OUTBOUND_MPNR = exports.DEFAULT_GROUP_KEYS_INBOUND_MPNR = exports.DEFAULT_FILTER_KEYS = exports.DEFAULT_DOMESTIC_FILTER_KEYS = exports.DEFAULT_DATE_FORMAT = exports.DEFAULT_BAGGAGE_WEIGHT_SV = exports.DEFAULT_BAGGAGE_WEIGHT = exports.DEFAULT_BAGGAGE_QUANTITY = exports.CREDIT_SHELL_AIRLINES = exports.COVID_SHEET_NAMES = exports.COVID_BANNER_REGEX = exports.CMS_PLATFORMS = exports.CHEAPEST_SORT_KEY = exports.CFAR_ONLINE_CHECKIN = exports.CFAR = exports.CABIN_TYPES_REGEX = exports.CABIN_TYPES = exports.BANNER_TYPES = exports.BANNERS_PATH_REGEX = exports.BAGGAGE_WEIGHT_FORMAT = exports.BAGGAGE_TYPES = exports.BAGGAGE_QUANTITY_FORMAT = exports.BAGGAGE_DIMENSIONS_KEY_REGEX = exports.ASYNC_POLLING_TIMEOUT = exports.AMENITIES_KEY_REGEX = exports.AMENITIES_CODE_SEPARATOR = exports.AIRPORT_IATA_REGEX = exports.AIRLINES_WITH_COVERAGE = exports.AIRCRAFT_TYPE = exports.AD_SOLUTION_PATH = exports.ADULT_MIN_AGE = exports.ADDON_UI_TYPE = exports.ADDON_TNC_MAP = exports.ADDON_PLACEMENT = exports.ADDON_MERGE_ALL = exports.ADDON_CURRENCY_ROUNDUP = exports.ADDONS_CONFIG = exports.ADDONS = exports.ACTION_TYPES = void 0;
exports.WORLD_CUP_FAN_ID = exports.VENDORS = exports.UNACCOMPANIED_MINOR_AIRLINES = exports.TRAVELLER_REQUIRED_VALUES = exports.TRAVELLER_CACHE_VALUES = exports.TRAVELLERS_TYPES_MAP = exports.TRAVELLERS_TYPES_CODES_MAP = exports.TRAVELLERS_TITLE_OPTIONS = exports.TOP_PICKS_VALUES = exports.TOP_PICKS_POPULAR_FLIGTHS_CODES = exports.TOP_PICKS_POPULAR_FLIGTHS = exports.TOP_AIRLINES = exports.TIME_FILTER_SEGMENTS = exports.TIME_FILTER_FARE_CALENDAR_MAP = exports.STOP_FILTER_CODES = exports.SORT_ORDER_MAP = exports.SORT_KEY_SEPARATOR = exports.SORT_BY_MAP = void 0;
var _constants = require("@tajawal/web-core-sdk-v2/lib/constants");
var _ADDON_TNC_MAP;
var QUERY_DATE_REGEX = exports.QUERY_DATE_REGEX = /^[\d]+-[\d]+-[\d]+$/;
var AIRPORT_IATA_REGEX = exports.AIRPORT_IATA_REGEX = /^[a-zA-Z]{3}$/;
var AMENITIES_KEY_REGEX = exports.AMENITIES_KEY_REGEX = /^[a-zA-Z]+-[\d]+_[A-Z][a-z]+$/;
var BAGGAGE_DIMENSIONS_KEY_REGEX = exports.BAGGAGE_DIMENSIONS_KEY_REGEX = /^[a-zA-Z]+_(domestic|international)+$/;
var ROUTE_REGEX = exports.ROUTE_REGEX = /^[a-zA-Z]{3}-[a-zA-Z]{3}$/;
var ROUTE_AIRLINE_REGEX = exports.ROUTE_AIRLINE_REGEX = /^[a-zA-Z]{3}-[a-zA-Z]{3}-[a-zA-Z]{2}$/;
var BANNERS_PATH_REGEX = exports.BANNERS_PATH_REGEX = /^([a-zA-Z]{3}|\*)-([a-zA-Z]{3}|\*)$/;
var CABIN_TYPES_REGEX = exports.CABIN_TYPES_REGEX = /(Business|Economy|Premium\sEconomy|First)/;
var COVID_BANNER_REGEX = exports.COVID_BANNER_REGEX = {
  COUNTRY_KEY_REGEX: /^[a-zA-Z]+$/,
  AIRLINE_KEY_REGEX: /^[a-zA-Z]{2}$/
};
var DEFAULT_DATE_FORMAT = exports.DEFAULT_DATE_FORMAT = "YYYY-MM-DD";
var FLEX_DATE_REGEX = exports.FLEX_DATE_REGEX = /(flex)+-[\d]+(d)/;
var ASYNC_POLLING_TIMEOUT = exports.ASYNC_POLLING_TIMEOUT = 500;
var PRICING_DATE_RANGE = exports.PRICING_DATE_RANGE = 7;
var MAX_SEAT_COUNT = exports.MAX_SEAT_COUNT = 5;
var ADULT_MIN_AGE = exports.ADULT_MIN_AGE = 12;
var INFANT_MAX_AGE = exports.INFANT_MAX_AGE = 2;
var ENDPOINTS = exports.ENDPOINTS = {
  CART_INFO: "/api/v3/flights/flight/quote/itineraryId/{itineraryId}",
  AIRPORT_LIST: "/api/v3/flights/service/shazam/api/search?query={query}",
  ASYNC_SEARCH_V3: "/api/v3/flights/flight/search?query={query}",
  ASYNC_SEARCH_V2: "/api/v3/flights/flight/v2/search?query={query}",
  ASYNC_SEARCH_RESULTS_V3: "/api/v3/flights/flight/async-search-result",
  ASYNC_SEARCH_RESULTS_V2: "/api/v3/flights/flight/v2/async-search-result",
  ASYNC_SEARCH_CART_INFO: "/api/v3/flights/flight/quote/itineraryId/{itineraryId}",
  INBOUND_SEARCH: "/api/v3/flights/flight/inbound-result",
  FARE_CALENDAR: "/api/v3/flights/flight/get-fares-calender",
  FARE_CALENDAR_BULK: "/api/v3/flights/flight/get-fares-calender-bulk",
  FLIGHT_RESOURCES: "/api/flight/resource/codes/{codes}",
  FLIGHT_FARE_RULES_NO_BOOKING: "/api/v3/flights/flight/fare-rules/no-booking",
  FLIGHT_FARE_RULES_PRE_BOOKING: "/api/v3/flights/flight/fare-rules/pre-booking?fareUuid={fareUuid}&vendor={vendor}&airline={airline}",
  FLIGHT_FARE_RULES_POST_BOOKING: "/api/v3/flights/flight/fare-rules/post-booking?fareUuid={fareUuid}&vendor={vendor}&airline={airline}",
  FLIGHT_AMENITIES: "/api/v3/flights/flight/rich-content?amenities={codes}",
  FLIGHT_RICH_CONTENT: "/api/v3/flights/flight/rich-content?amenities={amenitiesCodes}&airline_refund={airlineRefundCodes}&baggage_dimensions={baggageDimensionCodes}&baggage_weight_kg={baggageWeightCodes}",
  EXTRA_BAGGAGE: "/api/v3/flights/flight/rich-content?baggage_pre_booking={search}",
  LOYALTY_CALCULATE_BULK_REWARD: "/api/loyalty/bulk-calculate-reward",
  FARE_RULES_INFO: "/content/flight-fare-rules?lang={lang}&cancellation={cancellation}&change={change}&refundMethod={refundMethod}&pos={pos}",
  FARE_FAMILIES: "/api/v3/flights/flight/fetch-fare-families/itineraryId/{itineraryId}",
  FARE_FAMILIES_V2: "/api/v3/flights/flight/fetch-fare-families",
  CREATE_CART_V1: "/api/flight/quote/itineraryId/{itineraryId}",
  CREATE_CART: "/api/v3/flights/flight/quote/itineraryId/{itineraryId}",
  GET_CART: "/api/v3/flights/flight/cart/{cartId}",
  SEAT_RESERVATION: "/api/flight/seat/reservation",
  SEAT_RESERVATION_V3: "/api/v3/flights/flight/seat/reservation",
  UPDATE_SSR: "/api/flight/ssr/update",
  UPDATE_SSR_V3: "/api/v3/flights/flight/ssr/update",
  MULTI_SSR_V3_UPDATE: "/api/v3/flights/flight/v2/cart/{cartId}/ssr/update",
  CMS_V2: "/api/content/cms/json-content?platform={platform}&appId={appId}&uri={uri}",
  DISCLAIMERS: "/api/cms/page?param={query}",
  CREATE_SALE: "/api/v3/flights/flight/sale/quote/itineraryId/{itineraryId}",
  CREATE_SALE_FROM_CART: "/api/v3/flights/flight/sale/from-cart/{cartId}",
  GET_SALE: "/api/v3/flights/flight/sale/{saleId}",
  SSR_UPDATE: "/api/v3/flights/flight/sale/{saleId}/cart/{cartId}/ssr/update",
  MULTI_SSR_UPDATE: "/api/v3/flights/flight/v2/sale/{saleId}/cart/{cartId}/ssr/update",
  SALE_SEAT_RESERVATION: "/api/v3/flights/flight/sale/{saleId}/cart/{cartId}/seat/reservation",
  ADDON: "/api/v3/flights/flight/add-on",
  GET_ADD_ONS: "/api/v2/addon/miscellaneous/search",
  GET_ADD_ONS_V3: "/api/addon/miscellaneous/v3/search",
  APPLY_ADD_ON: "/api/v3/flights/flight/sale/{saleId}/cart/{cartId}/miscellaneous",
  REMOVE_ADD_ON: "/api/v3/flights/flight/sale/{saleId}/cart/{cartId}/miscellaneous/{packageId}",
  REMOVE_ADD_ON_TYPE: "/api/v3/flights/flight/{saleId}/delete/miscellaneous/{type}"
};
var TRAVELLERS_TYPES_CODES_MAP = exports.TRAVELLERS_TYPES_CODES_MAP = {
  ADT: "ADT",
  CH: "CH",
  INF: "INF",
  CHD: "CHD"
};
var PAX_TYPES = exports.PAX_TYPES = {
  ADT: "Adults",
  CH: "Children",
  INF: "Infants"
};
var TRAVELLERS_TYPES_MAP = exports.TRAVELLERS_TYPES_MAP = {
  ADULT: {
    code: TRAVELLERS_TYPES_CODES_MAP.ADT,
    label: "adult"
  },
  CHILD: {
    code: TRAVELLERS_TYPES_CODES_MAP.CH,
    label: "child"
  },
  INFANT: {
    code: TRAVELLERS_TYPES_CODES_MAP.INF,
    label: "infant"
  }
};
var FARE_RULES_PAX_CODE = exports.FARE_RULES_PAX_CODE = {
  CHILD: "CHD"
};
var MIN_PAX_COUNT = exports.MIN_PAX_COUNT = {
  ADULTS: 1,
  CHILDREN: 0,
  INFANTS: 0
};
var EXTRA_BAGGAGE_FULL_TRIP = exports.EXTRA_BAGGAGE_FULL_TRIP = "Complete Journey";
var BAGGAGE_QUANTITY_FORMAT = exports.BAGGAGE_QUANTITY_FORMAT = "n";
var BAGGAGE_WEIGHT_FORMAT = exports.BAGGAGE_WEIGHT_FORMAT = "w";
var TRAVELLERS_TITLE_OPTIONS = exports.TRAVELLERS_TITLE_OPTIONS = ["Mr", "Ms", "Mrs"];
var TRAVELLER_REQUIRED_VALUES = exports.TRAVELLER_REQUIRED_VALUES = {
  BASIC: ["firstName", "lastName", "title"],
  APIS_REQUIRED: ["nationality"],
  DOB_REQUIRED: ["birthDate", "birthDateDay", "birthDateMonth", "birthDateYear"],
  ID_REQUIRED: ["idType", "idNumber", "idExpiryDate", "idExpiryDateDay", "idExpiryDateMonth", "idExpiryDateYear", "issuingCountry", "nationality"]
};
var TRAVELLER_CACHE_VALUES = exports.TRAVELLER_CACHE_VALUES = ["id", "type", "firstName", "middleName", "lastName", "title", "birthDate", "birthDateIsHijri", "birthDateDay", "birthDateMonth", "birthDateYear", "idType", "idNumber", "idExpiryDate", "idExpiryDateDay", "idExpiryDateMonth", "idExpiryDateYear", "idExpiryDateIsHijri", "issuingCountry", "nationality"];
var ID_TYPES = exports.ID_TYPES = {
  PASSPORT: "passport",
  NATIONAL_ID: "nationalId",
  IQAMA_ID: "iqamaId"
};
var DEFAULT_FILTER_KEYS = exports.DEFAULT_FILTER_KEYS = ["price", "stop", "departureTime", "airport", "airline", "insuranceOnly", "hasBaggageOnly", "isFlex"];
var DEFAULT_DOMESTIC_FILTER_KEYS = exports.DEFAULT_DOMESTIC_FILTER_KEYS = ["price", "departureTime", "airline"];
var FILTER_PARAMS_MAP = exports.FILTER_PARAMS_MAP = {
  price: "p",
  stop: "s",
  departureTime: "dt",
  arrivalTime: "at",
  airport: "ap",
  airline: "ar",
  maxStop: "s",
  insuranceOnly: "ic",
  hasBaggageOnly: "bg",
  isFlex: "if"
};
var FILTER_PARAM_AIRPORT_SEPARATOR = exports.FILTER_PARAM_AIRPORT_SEPARATOR = ";";
var FILTER_PARAM_LEG_SEPARATOR = exports.FILTER_PARAM_LEG_SEPARATOR = "*";
var FILTER_PARAM_LEG_ITEM_SEPARATOR = exports.FILTER_PARAM_LEG_ITEM_SEPARATOR = ",";
var FILTER_PARAM_RANGE_SEPARATOR = exports.FILTER_PARAM_RANGE_SEPARATOR = "-";
var FILTER_PARAM_ALL_ITEM = exports.FILTER_PARAM_ALL_ITEM = "all";
var FILTER_PARAM_ALL_AIRPORTS = exports.FILTER_PARAM_ALL_AIRPORTS = "" + FILTER_PARAM_ALL_ITEM + FILTER_PARAM_AIRPORT_SEPARATOR + FILTER_PARAM_ALL_ITEM;
var TIME_FILTER_SEGMENTS = exports.TIME_FILTER_SEGMENTS = {
  AM: {
    code: "am",
    from: 0,
    to: 5
  },
  AM2: {
    code: "am2",
    from: 6,
    to: 11
  },
  PM: {
    code: "pm",
    from: 12,
    to: 17
  },
  PM2: {
    code: "pm2",
    from: 18,
    to: 23
  }
};
var TIME_FILTER_FARE_CALENDAR_MAP = exports.TIME_FILTER_FARE_CALENDAR_MAP = {
  am: 0,
  am2: 1,
  pm: 2,
  pm2: 3
};
var STOP_FILTER_CODES = exports.STOP_FILTER_CODES = [0, 1, 2];
var SORT_ORDER_MAP = exports.SORT_ORDER_MAP = {
  ASC: "asc",
  DESC: "desc"
};
var SORT_BY_MAP = exports.SORT_BY_MAP = {
  price: "totalPrice",
  duration: "itineraryDuration",
  departure: "firstLegDepartureTime",
  arrival: "lastLegDepartureTime",
  bestScore: "bestScore",
  cheapestScore: "cheapestScore",
  shortestScore: "shortestScore",
  earliestDeparture: "firstLegDepartureTime",
  latestDeparture: "firstLegDepartureTime",
  earliestArrival: "lastLegDepartureTime",
  latestArrival: "lastLegDepartureTime"
};
var SORT_KEY_SEPARATOR = exports.SORT_KEY_SEPARATOR = ":";
var DEFAULT_SORT_KEY = exports.DEFAULT_SORT_KEY = SORT_BY_MAP.cheapestScore + SORT_KEY_SEPARATOR + SORT_ORDER_MAP.ASC;
var CHEAPEST_SORT_KEY = exports.CHEAPEST_SORT_KEY = "price" + SORT_KEY_SEPARATOR + SORT_ORDER_MAP.ASC;
var SORTING_BY_MAP = exports.SORTING_BY_MAP = {
  bestScore: "bestScore:asc",
  cheapestScore: "cheapestScore:asc",
  shortestScore: "shortestScore:asc",
  earlistDeparture: "departure:asc",
  lastestDeparture: "departure:desc",
  earlistArrival: "arrival:asc",
  latestArrival: "arrival:desc"
};
var DEFAULT_SORTING_LOGIC = exports.DEFAULT_SORTING_LOGIC = "a";
var FLIGHT_PROPERTY_WEIGHT_MAP = exports.FLIGHT_PROPERTY_WEIGHT_MAP = {
  totalPrice: 2,
  itineraryDuration: 1
};
var DEFAULT_GROUP_PATHS = exports.DEFAULT_GROUP_PATHS = ["validatingCarrier", "totalPrice", "firstLegDepartureDay"];
var DEFAULT_GROUP_KEYS_OUTBOUND_MPNR = exports.DEFAULT_GROUP_KEYS_OUTBOUND_MPNR = ["validatingCarrier", "cheapestRoundtripTotal", "firstLegDepartureDay"];
var DEFAULT_GROUP_KEYS_INBOUND_MPNR = exports.DEFAULT_GROUP_KEYS_INBOUND_MPNR = ["validatingCarrier", "roundtripTotal", "firstLegDepartureDay"];
var GROUP_VALUES_SEPARATOR = exports.GROUP_VALUES_SEPARATOR = "-";
var LEG_IDS_SEPARATOR = exports.LEG_IDS_SEPARATOR = "/";
var MIN_GROUP_LENGTH = exports.MIN_GROUP_LENGTH = 1;
var PRICING_KEY_SEPARATOR = exports.PRICING_KEY_SEPARATOR = "_";
var OUTBOUND = exports.OUTBOUND = "outbound";
var INBOUND = exports.INBOUND = "inbound";
var FLIGHT_DIRECTIONS = exports.FLIGHT_DIRECTIONS = [OUTBOUND, INBOUND];
var DOMESTIC_ID_SEPARATOR = exports.DOMESTIC_ID_SEPARATOR = "/";
var DOMESTIC_ALLOWED_HOUR_DIFFERENCE = exports.DOMESTIC_ALLOWED_HOUR_DIFFERENCE = 3;
var AIRCRAFT_TYPE = exports.AIRCRAFT_TYPE = {
  M11: "BOEING DOUGLAS",
  M80: "BOEING DOUGLAS",
  M8T: "BOEING DOUGLAS",
  M81: "BOEING DOUGLAS",
  M82: "BOEING DOUGLAS",
  M83: "BOEING DOUGLAS",
  M88: "BOEING DOUGLAS",
  M90: "BOEING DOUGLAS",
  "70F": "BOEING - 707",
  "70M": "BOEING 707 MIXED",
  703: "BOEING 707 - 320/32",
  707: "BOEING 707/720B J",
  717: "BOEING 717 JET 10",
  720: "BOEING - 720/720B N",
  B72: "BOEING - 720/720B",
  "72F": "BOEING - 727",
  721: "BOEING - 727",
  "72X": "BOEING - 727",
  "72M": "BOEING - 727",
  "72B": "BOEING - 727",
  727: "BOEING - 727",
  722: "BOEING - 727",
  "72A": "BOEING - 727",
  "72C": "BOEING - 727",
  "72W": "BOEING - 727",
  "72S": "BOEING - 727",
  "73V": "BOEING - 737",
  "73I": "BOEING - 737",
  737: "BOEING - 737",
  "7M7": "BOEING - 737",
  "7M8": "BOEING - 737",
  731: "BOEING - 737",
  732: "BOEING - 737",
  "73A": "BOEING - 737",
  "73B": "BOEING - 737",
  "73Z": "BOEING - 737",
  "73X": "BOEING - 737",
  "73L": "BOEING - 737",
  "73M": "BOEING - 737",
  "73S": "BOEING - 737",
  "73F": "BOEING - 737",
  733: "BOEING - 737",
  "73C": "BOEING - 737",
  "73Y": "BOEING - 737",
  "73N": "BOEING - 737",
  734: "BOEING - 737",
  "73P": "BOEING - 737",
  "73Q": "BOEING - 737",
  735: "BOEING - 737",
  "73E": "BOEING - 737",
  736: "BOEING - 737",
  "73G": "BOEING - 737",
  "73W": "BOEING - 737",
  "73R": "BOEING - 737",
  738: "BOEING - 737",
  "73H": "BOEING - 737",
  "7S8": "BOEING - 737",
  739: "BOEING - 737",
  "73J": "BOEING - 737",
  747: "BOEING - 747",
  741: "BOEING - 747",
  "74T": "BOEING - 747",
  "74F": "BOEING - 747",
  "74X": "BOEING - 747",
  742: "BOEING - 747",
  "72Y": "BOEING - 747",
  "74C": "BOEING - 747",
  "74M": "BOEING - 747",
  743: "BOEING - 747",
  "76V": "BOEING - 747",
  "74D": "BOEING - 747",
  "74V": "BOEING - 747",
  744: "BOEING - 747",
  "74J": "BOEING - 747",
  "74Y": "BOEING - 747",
  "74E": "BOEING - 747",
  "74B": "BOEING - 747",
  "74N": "BOEING - 747",
  "74H": "BOEING - 747",
  "74L": "BOEING - 747",
  "74R": "BOEING - 747",
  757: "BOEING - 757",
  "75L": "BOEING - 757",
  "75N": "BOEING - 757",
  "75S": "BOEING - 757",
  "75F": "BOEING - 757",
  B75: "BOEING - 757",
  752: "BOEING - 757",
  "75W": "BOEING - 757",
  "75M": "BOEING - 757",
  "75O": "BOEING - 757",
  753: "BOEING - 757",
  "75T": "BOEING - 757",
  767: "BOEING - 767",
  "76P": "BOEING - 767",
  "76F": "BOEING - 767",
  "76X": "BOEING - 767",
  762: "BOEING - 767",
  "76Q": "BOEING - 767",
  "76S": "BOEING - 767",
  "76W": "BOEING - 767",
  "76Z": "BOEING - 767",
  "76Y": "BOEING - 767",
  763: "BOEING - 767",
  "76G": "BOEING - 767",
  764: "BOEING - 767",
  765: "BOEING - 767",
  "77F": "BOEING - 777",
  772: "BOEING - 777",
  777: "BOEING - 777",
  "77X": "BOEING - 777",
  "77L": "BOEING - 777",
  773: "BOEING - 777",
  "77W": "BOEING - 777",
  783: "BOEING - 787",
  788: "BOEING - 787",
  789: "BOEING - 787",
  787: "BOEING - 787",
  D1M: "BOEING - DC",
  D1X: "BOEING - DC1",
  D1Y: "BOEING - DC1",
  D3F: "BOEING - DC3",
  D8T: "BOEING - DC8",
  D8X: "BOEING - DC8",
  D8Y: "BOEING - DC8",
  D9X: "BOEING - DC9",
  D9C: "BOEING - DC9",
  D9D: "BOEING - DC9",
  DC4: "BOEING DOUGLAS DC",
  M2F: "BOEING DOUGLAS MD",
  M3F: "BOEING DOUGLAS MD",
  M8F: "BOEING DOUGLAS MD",
  AB3: "AIRBUS - A300",
  ABA: "AIRBUS - A300",
  ABF: "AIRBUS - A300",
  ABY: "AIRBUS - A300",
  AB6: "AIRBUS - A300",
  ABB: "AIRBUS - A300",
  AB2: "AIRBUS - A300",
  AB4: "AIRBUS - A300",
  ABM: "AIRBUS - A300",
  ABX: "AIRBUS - A300",
  310: "AIRBUS - A310",
  314: "AIRBUS - A310",
  "31F": "AIRBUS - A310",
  312: "AIRBUS - A310",
  315: "AIRBUS - A310",
  "31X": "AIRBUS - A310",
  313: "AIRBUS - A310",
  "31Y": "AIRBUS - A310",
  318: "AIRBUS - A318",
  "31A": "AIRBUS - A318",
  "32S": "AIRBUS - A318",
  319: "AIRBUS - A319",
  "31B": "AIRBUS - A319",
  "32N": "AIRBUS - A320",
  "32F": "AIRBUS - A320",
  "32A": "AIRBUS - A320",
  320: "AIRBUS - A320",
  322: "AIRBUS - A320",
  "32Z": "AIRBUS - A320",
  321: "AIRBUS - A321",
  "21F": "AIRBUS - A321",
  "21S": "AIRBUS - A321",
  "32X": "AIRBUS - A321",
  "32B": "AIRBUS - A321",
  "32Q": "AIRBUS - A321neo",
  330: "AIRBUS - A330",
  332: "AIRBUS - A330",
  333: "AIRBUS - A330",
  340: "AIRBUS - A340",
  342: "AIRBUS - A340",
  343: "AIRBUS - A340",
  345: "AIRBUS - A340",
  346: "AIRBUS - A340",
  350: "AIRBUS - A350",
  351: "AIRBUS - A350",
  358: "AIRBUS - A350",
  359: "AIRBUS - A350",
  380: "AIRBUS - A380",
  "38F": "AIRBUS - A380",
  388: "AIRBUS - A380",
  ANF: "ANTONOV - 12 F",
  A4F: "ANTONOV - 124",
  A40: "ANTONOV - 140",
  A81: "ANTONOV - 148",
  A58: "ANTONOV - 158",
  AN2: "ANTONOV - 2 TU",
  A22: "ANTONOV - 22 T",
  A5F: "ANTONOV - 225",
  AN4: "ANTONOV - 24 T",
  A26: "ANTONOV - 26 T",
  AN6: "ANTONOV - 26/3",
  A30: "ANTONOV - 30 T",
  A32: "ANTONOV - 32 T",
  A38: "ANTONOV - 38 T",
  AN7: "ANTONOV - 72/7",
  A28: "ANTONOV ",
  HS7: "Hawker Siddeley",
  ACP: "Gulfstream",
  ACT: "Gulfstream",
  AT4: "ATR 42",
  AT5: "ATR 42",
  ATR: "ATR 42",
  AT7: "ATR 72",
  ATL: "Robin ATL",
  ATP: "British Aerospace ATP",
  MBH: "Eurocopter",
  BEH: "Beechcraft 1900",
  BH2: "Bell 212",
  141: "BAE146",
  142: "BAE146",
  143: "BAE 146",
  CCX: "BOMBARDIER - BD",
  CL3: "BOMBARDIER - C",
  CL5: "BOMBARDIER - C",
  CS1: "BOMBARDIER - CS",
  CS3: "BOMBARDIER - CS",
  LOH: "LOCKHEED - 100",
  L11: "LOCKHEED - 1011",
  L1F: "LOCKHEED - 1011",
  L10: "LOCKHEED - 1011",
  L1A: "LOCKHEED - 1011",
  L12: "LOCKHEED - 1011",
  L15: "LOCKHEED - 1011",
  LOE: "LOCKHEED - 188",
  LOF: "LOCKHEED - MARTIN",
  L19: "LOCKHEED - TRISTA",
  CNC: "CESSNA",
  CNA: "CESSNA",
  CNF: "CESSNA",
  CN1: "CESSNA",
  CN4: "CESSNA",
  CJ1: "CESSNA",
  CJM: "CESSNA",
  CJ2: "CESSNA",
  CJ5: "CESSNA",
  CJL: "CESSNA",
  CJ6: "CESSNA",
  CJ8: "CESSNA",
  CJ7: "CESSNA",
  CN7: "CESSNA",
  CJX: "CESSNA",
  CNJ: "CESSNA",
  CN2: "CESSNA",
  CND: "CESSNA",
  CNT: "CESSNA",
  MD8: "MC DONNELL - JET 125",
  D1F: "MC DONNELL - DC-10",
  D11: "MC DONNELL - DC-10",
  D1C: "MC DONNELL - DC-10",
  D14: "MC DONNELL - DC-10",
  D8S: "MC DONNELL - DC-8",
  D86: "MC DONNELL - DC-8",
  D8L: "MC DONNELL - DC-8",
  D8A: "MC DONNELL - DC-8",
  D87: "MC DONNELL - DC-8",
  D8Q: "MC DONNELL - DC-8",
  D8B: "MC DONNELL - DC-8",
  D85: "MC DONNELL - DC-8",
  DC9: "MC DONNELL - DC-9",
  D9F: "MC DONNELL - DC-9",
  D91: "MC DONNELL - DC-9",
  D92: "MC DONNELL - DC-9",
  D93: "MC DONNELL - DC-9",
  D9S: "MC DONNELL - DC-9",
  D94: "MC DONNELL - DC-9",
  D95: "MC DONNELL - DC-9",
  D98: "MC DONNELL - DC-9",
  EM6: "EMBRAER",
  E70: "EMBRAER - 170",
  E75: "EMBRAER - 175",
  E7W: "EMBRAER - 175",
  E90: "EMBRAER - 190",
  E95: "EMBRAER - 195",
  EM4: "EMBRAER - 450",
  EM5: "EMBRAER - 500",
  EMB: "EMBRAER - EMB",
  EM2: "EMBRAER - EMB",
  EP1: "EMBRAER - EMB",
  EP3: "EMBRAER - EMB",
  EM3: "EMBRAER - RJ1",
  ER3: "EMBRAER - RJ1",
  ERJ: "EMBRAER - RJ1",
  ERD: "EMBRAER - RJ1",
  ER4: "EMBRAER - RJ1",
  EM7: "EMBRAER - RJ1",
  EMJ: "EMBRAER - RJ1",
  EM9: "EMBRAER - RJ1",
  F7B: "FOKKER - JET",
  100: "FOKKER - 100",
  F50: "FOKKER - 50",
  FO5: "FOKKER - 50",
  F5F: "FOKKER - 50",
  F70: "FOKKER - 70",
  F27: "FOKKER - F27",
  F2A: "FOKKER - F27",
  F2C: "FOKKER - F27",
  F2D: "FOKKER - F27",
  F2S: "FOKKER - F27",
  F21: "FOKKER - F28",
  F22: "FOKKER - F28",
  F23: "FOKKER - F28",
  F24: "FOKKER - F28",
  F28: "FOKKER - F28",
  GRJ: "GULFSTREAM",
  GRS: "GULFSTREAM",
  GR1: "GULFSTREAM",
  GR2: "GULFSTREAM",
  GR3: "GULFSTREAM",
  H7M: "BRITISH AERO",
  H25: "BRITISH AERO",
  VGF: "BRITISH AERO",
  VCV: "BRITISH AERO",
  HPH: "BRITISH AERO",
  HPJ: "BRITISH AERO",
  HSF: "BRITISH AERO",
  HSM: "BRITISH AERO",
  TRD: "BRITISH AERO",
  BAE: "BRITISH AERO",
  B11: "BRITISH AERO",
  B12: "BRITISH AERO",
  B13: "BRITISH AERO",
  B14: "BRITISH AERO",
  B15: "BRITISH AERO",
  "14F": "BRITISH AERO",
  146: "BRITISH AERO",
  DHH: "BRITISH AERO",
  J31: "BRITISH AERO",
  JST: "BRITISH AERO",
  J32: "BRITISH AERO",
  J41: "BRITISH AERO",
  VGP: "BRITISH AERO",
  DHF: "HAVILLAND - BOMBARDIER",
  DHP: "HAVILLAND - DHC-2",
  DHR: "HAVILLAND - DHC-2",
  DHB: "HAVILLAND - DHC-2",
  DHO: "HAVILLAND - DHC-3",
  DHS: "HAVILLAND - DHC-3",
  DHL: "HAVILLAND - DHC-3",
  DHC: "HAVILLAND - DHC-4",
  DHT: "HAVILLAND - DHC-6",
  DH7: "HAVILLAND - DHC-7",
  DHM: "HAVILLAND - DHC-7",
  DH1: "HAVILLAND - DHC-8",
  DH2: "HAVILLAND - DHC-8",
  DH4: "HAVILLAND - DHC-8",
  DH8: "HAVILLAND - DHC-8",
  DH3: "HAVILLAND - DHC-8",
  D4X: "HAVILLAND - DHC-8",
  I9F: "ILYUSHIN - II-96",
  I14: "ILYUSHIN - IL-114",
  IL4: "ILYUSHIN - IL-14",
  IL8: "ILYUSHIN - IL-18",
  IL6: "ILYUSHIN - IL-62",
  IL7: "ILYUSHIN - IL-76",
  ILW: "ILYUSHIN - IL-86",
  IL9: "ILYUSHIN - IL-96",
  ARJ: "AVRO RJ",
  AR1: "AVRO RJ",
  AR7: "AVRO RJ",
  AR8: "AVRO RJ",
  ARX: "AVRO RJ",
  AX1: "AVRO RJ",
  AX8: "AVRO RJ",
  T5M: "TUPOLEV - 154",
  TU3: "TUPOLEV - TU",
  T54: "TUPOLEV - TU",
  TU5: "TUPOLEV - TU",
  T34: "TUPOLEV - TU",
  T2F: "TUPOLEV - TU",
  T20: "TUPOLEV - TU",
  YK4: "YAKOVLEV - 40",
  YK2: "YAKOVLEV - 42",
  S58: "SIKORSKY",
  S61: "SIKORSKY - 61",
  S76: "SIKORSKY - 76",
  P12: "PILATUS",
  BNI: "PILATUS",
  BNT: "PILATUS",
  PL2: "PILATUS",
  PL6: "PILATUS",
  PAG: "PIPER",
  PA6: "PIPER",
  PAZ: "PIPER",
  PAC: "PIPER",
  PA2: "PIPER",
  PAH: "PIPER",
  PAS: "PIPER",
  PA1: "PIPER",
  PAT: "PIPER"
};
var VENDORS = exports.VENDORS = {
  AMD: "amd",
  TF: "tf",
  TF_CODES: ["tf", "tfn", "TFN"],
  TPT: "tpt",
  ONE: "one"
};
var LOCATION_TYPES = exports.LOCATION_TYPES = {
  AIRPORT: "4",
  BUS: "7",
  CITY: "6",
  TRAIN: "8"
};
var CABIN_TYPES = exports.CABIN_TYPES = {
  ECONOMY: "Economy",
  PREMIUM_ECONOMY: "Premium Economy",
  BUSINESS: "Business",
  FIRST_CLASS: "First"
};
var BAGGAGE_TYPES = exports.BAGGAGE_TYPES = {
  CABIN: "cabin",
  CHECKED: "checked",
  CHECK_IN: "checkIn"
};
var DOMESTIC_AIRPORTS = exports.DOMESTIC_AIRPORTS = ["ABT", "AHB", "AJF", "AQI", "BHH", "DMM", "DWD", "EAM", "EJH", "ELQ", "GIZ", "HAS", "HOF", "JED", "MED", "RAE", "RAH", "RUH", "SHW", "TIF", "TUI", "TUU", "ULH", "URY", "WAE", "YNB", "NUM", "RSI"];
var SAUDI_AIRLINE_CODE = exports.SAUDI_AIRLINE_CODE = "SV";
var SEARCH_TYPES = exports.SEARCH_TYPES = {
  ONE_WAY: "oneway",
  ROUND_TRIP: "roundtrip",
  MULTI_CITY: "multicity"
};
var AMENITIES_CODE_SEPARATOR = exports.AMENITIES_CODE_SEPARATOR = "_";
var BANNER_TYPES = exports.BANNER_TYPES = {
  FILTER: "filter",
  COPY: "copy"
};
var HAJJ_UMRAH_AIRPORTS = exports.HAJJ_UMRAH_AIRPORTS = ["JED", "MED", "RUH"];
var HAJJ_UMRAH_FLIGHTS = exports.HAJJ_UMRAH_FLIGHTS = ["FZ-7417", "FZ-7423", "FZ-7427", "FZ-7425", "FZ-7431", "FZ-7429", "FZ-7435", "FZ-7433", "FZ-7439", "FZ-7437", "FZ-7443", "FZ-7439", "FZ-7437", "FZ-7443", "FZ-7441", "FZ-7447", "FZ-7445", "FZ-7451", "FZ-7455", "FZ-7426", "FZ-7430", "FZ-7434", "FZ-7444", "FZ-7438", "FZ-7442", "FZ-7448", "FZ-7446", "FZ-7452", "FZ-7456", "FZ-7012", "G9-1697", "G9-1699", "G9-1683", "G9-1691", "G9-1695", "G9-1693", "G9-1681", "G9-1698", "G9-1690", "G9-1684", "G9-1692", "G9-1696", "G9-1694", "G9-1682", "ET-2423", "ET-2422", "G9-1692", "G9-1696", "G9-1693", "G9-1697", "G9-1699", "G9-1683", "G9-1691", "G9-1695", "G9-1693", "G9-1681", "G9-1783", "G9-1787", "G9-1789", "G9-1763", "G9-1676", "G9-1678", "G9-1660", "G9-1781", "G9-1685", "G9-1761", "G9-1785", "G9-1689", "G9-1687", "G9-1767", "G9-1765", "G9-1769", "G9-1670", "G9-1672", "G9-1674", "G9-1662", "G9-1698", "G9-1690", "G9-1684", "G9-1692", "G9-1696", "G9-1694", "G9-1682", "G9-1784", "G9-1788", "G9-1780", "G9-1764", "G9-1677", "G9-1679", "G9-1661", "G9-1782", "G9-1686", "G9-1762", "G9-1786", "G9-1680", "G9-1688", "G9-1768", "G9-1766", "G9-1760", "G9-1671", "G9-1673", "G9-1675", "G9-1663", "G9-1613", "FZ-7223", "FZ-7225", "FZ-7227", "FZ-7229", "FZ-7231", "FZ-7233", "FZ-7235", "FZ-7237", "FZ-7239", "FZ-7241", "FZ-7243", "FZ-7245", "FZ-7247", "FZ-7249", "FZ-7251", "FZ-7253", "FZ-7255", "FZ-7257", "FZ-7259", "FZ-7261", "FZ-7263", "FZ-7265", "FZ-7267", "FZ-7269", "FZ-7271", "FZ-7273", "FZ-7275", "FZ-7277", "FZ-7279", "FZ-7281", "FZ-7283", "FZ-7285", "FZ-7287", "FZ-7289", "FZ-7291", "FZ-7293", "FZ-7295", "FZ-7297", "FZ-7299", "FZ-7301", "FZ-7303", "FZ-7305", "FZ-7307", "FZ-7309", "FZ-7311", "FZ-7313", "FZ-7315", "FZ-7317", "FZ-7319", "FZ-7321", "FZ-7323", "FZ-7325", "FZ-7327", "FZ-7329", "FZ-7331", "FZ-7333", "FZ-7335", "FZ-7337", "FZ-7339", "FZ-7341", "FZ-7343", "FZ-7345", "FZ-7347", "FZ-7349", "FZ-7351", "FZ-7353", "FZ-7355", "FZ-7224", "FZ-7226", "FZ-7228", "FZ-7230", "FZ-7232", "FZ-7234", "FZ-7236", "FZ-7238", "FZ-7240", "FZ-7242", "FZ-7244", "FZ-7246", "FZ-7248", "FZ-7250", "FZ-7252", "FZ-7254", "FZ-7256", "FZ-7258", "FZ-7260", "FZ-7262", "FZ-7264", "FZ-7266", "FZ-7268", "FZ-7270", "FZ-7272", "FZ-7274", "FZ-7276", "FZ-7278", "FZ-7280", "FZ-7282", "FZ-7284", "FZ-7286", "FZ-7288", "FZ-7290", "FZ-7292", "FZ-7294", "FZ-7296", "FZ-7298", "FZ-7300", "FZ-7302", "FZ-7304", "FZ-7306", "FZ-7308", "FZ-7310", "FZ-7312", "FZ-7314", "FZ-7316", "FZ-7318", "FZ-7320", "FZ-7322", "FZ-7324", "FZ-7326", "FZ-7328", "FZ-7330", "FZ-7332", "FZ-7334", "FZ-7336", "FZ-7338", "FZ-7340", "FZ-7342", "FZ-7344", "FZ-7346", "FZ-7348", "FZ-7350", "FZ-7352", "FZ-7354", "FZ-7356", "J9-1773", "J9-1770", "J9-1771", "J9-1775", "J9-1773", "J9-1770", "J9-1771", "J9-1775", "J9-1774"];
var FREQUENT_FLYER_SEPARATOR = exports.FREQUENT_FLYER_SEPARATOR = "-";
var FREQUENT_FLYER_GROUP_MAP = exports.FREQUENT_FLYER_GROUP_MAP = {
  "Star Alliance": ["A3", "AC", "CA", "NZ", "OZ", "AV", "SN", "CM", "MS", "ET", "BR", "LH", "SQ", "SA", "TP", "TG", "TK", "UA", "LX"],
  SkyTeam: ["SU", "AR", "AM", "UX", "KL", "AF", "KQ", "AZ", "CI", "MU", "CZ", "OK", "DL", "GA", "KE", "ME", "SV", "VN", "MF"],
  Oneworld: ["AB", "AA", "BA", "CX", "AY", "IB", "JL", "MH", "QF", "QR", "RJ", "S7", "UL"]
};
var FREQUENT_FLYERS_MAP = exports.FREQUENT_FLYERS_MAP = {
  A3: {
    operatorCode: "A3",
    country: "Greece",
    group: "Star Alliance",
    label: {
      en: "Aegean Airlines - Miles+Bonus",
      ar: "الخطوط الجوية ايجه - الأميال+ بونص"
    }
  },
  EI: {
    operatorCode: "EI",
    country: "Ireland",
    label: {
      en: "Aer Lingus - AerClub",
      ar: "إير لينجوس - آير كلوب"
    }
  },
  SU: {
    operatorCode: "SU",
    country: "Russia",
    group: "SkyTeam",
    label: {
      en: "Aeroflot - Bonus",
      ar: "إيروفلوت - بونص"
    }
  },
  AR: {
    operatorCode: "AR",
    country: "Argentina",
    group: "SkyTeam",
    label: {
      en: "Aerolineas Argentinas - Aerolíneas Plus",
      ar: "الخطوط الجوية الأرجنتينية - أيرولينياس بلاس"
    }
  },
  AM: {
    operatorCode: "AM",
    country: "Mexico",
    group: "SkyTeam",
    label: {
      en: "AeroMexico - Club Premier",
      ar: "طيران المكسيك - كلوب بريمير"
    }
  },
  AC: {
    operatorCode: "AC",
    country: "Canada",
    group: "Star Alliance",
    label: {
      en: "Air Canada - Aeroplan",
      ar: "طيران كندا - ايرو بلان"
    }
  },
  "8U": {
    operatorCode: "8U",
    country: "Libya",
    label: {
      en: "Afriqiyah Airways - Rahal",
      ar: "الخطوط الجوية الأفريقية - رحال"
    }
  },
  ZI: {
    operatorCode: "ZI",
    country: "France",
    label: {
      en: "Aigle Azur - Azur Plus",
      ar: "إيغل أزور - أزور بلاس"
    }
  },
  AH: {
    operatorCode: "AH",
    country: "Algeria",
    label: {
      en: "Air Algérie - Air Algérie Plus",
      ar: "الخطوط الجوية الجزائرية -  إير ألجيري بلاس"
    }
  },
  G9: {
    operatorCode: "G9",
    country: "UAE",
    label: {
      en: "Air Arabia - Airewards",
      ar: "العربية للطيران - إير واردز"
    }
  },
  KC: {
    operatorCode: "KC",
    country: "Kazakhstan",
    label: {
      en: "Air Astana - Nomad Club",
      ar: "العربية للطيران - إير واردز"
    }
  },
  UU: {
    operatorCode: "UU",
    country: "Réunion",
    label: {
      en: "Air Austral - Capricorne",
      ar: "إير أوسترال - كابريكون"
    }
  },
  AB: {
    operatorCode: "AB",
    country: "Germany",
    group: "Oneworld",
    label: {
      en: "Air Berlin - topbonus",
      ar: "طيران برلين - توب بونس"
    }
  },
  BP: {
    operatorCode: "BP",
    country: "Botswana",
    label: {
      en: "Air Botswana - Teemane Club",
      ar: "الخطوط الجوية البوتسوانية - تيمان كلوب"
    }
  },
  "2J": {
    operatorCode: "2J",
    country: "Burkina Faso",
    label: {
      en: "Air Burkina - Celestars",
      ar: "طيران بوركينا - سيلي ستارز"
    }
  },
  CA: {
    operatorCode: "CA",
    country: "PR China",
    group: "Star Alliance",
    label: {
      en: "Air China - PhoenixMiles",
      ar: "طيران الصين - فونكس مايلز"
    }
  },
  UX: {
    operatorCode: "UX",
    country: "Spain",
    group: "SkyTeam",
    label: {
      en: "Air Europa - SUMA",
      ar: "طيران أوروبا - سوما"
    }
  },
  KL: {
    operatorCode: "KL",
    country: "Netherlands",
    group: "SkyTeam",
    label: {
      en: "KLM - Flying Blue",
      ar: "الخطوط الجوية الملكية الهولندية - فلاينج بلو"
    }
  },
  AF: {
    operatorCode: "AF",
    country: "France",
    group: "SkyTeam",
    label: {
      en: "Air France - Flying Blue",
      ar: "الخطوط الجوية الفرنسيه - فلاينج بلو"
    }
  },
  AI: {
    operatorCode: "AI",
    country: "India",
    label: {
      en: "Air India - Flying Returns",
      ar: "طيران الهند - فلاينج ريتيرنز"
    }
  },
  KQ: {
    operatorCode: "KQ",
    country: "Kenya",
    group: "SkyTeam",
    label: {
      en: "Kenya Airways - Ndege Plus",
      ar: "الخطوط الجوية الكينية - ان دي اي جي اي بلاس"
    }
  },
  NX: {
    operatorCode: "NX",
    country: "PR China",
    label: {
      en: "Air Macau - Privileges",
      ar: "طيران ماكاو - بريفيليج"
    }
  },
  MD: {
    operatorCode: "MD",
    country: "Madagascar",
    label: {
      en: "Air Madagascar - Namako",
      ar: "طيران مدغشقر - ناماكو"
    }
  },
  KM: {
    operatorCode: "KM",
    country: "Malta",
    label: {
      en: "Air Malta - Flypass",
      ar: "طيران مالطا -  فلاي باس"
    }
  },
  MK: {
    operatorCode: "MK",
    country: "Mauritius",
    label: {
      en: "Air Mauritius - Kestrelflyer",
      ar: "طيران موريشيوس - كيستر فلاير"
    }
  },
  "9U": {
    operatorCode: "9U",
    country: "Moldavia",
    label: {
      en: "Air Moldova - Air Moldova Club",
      ar: "طيران مولدوفا - اير مولدوفا كلوب"
    }
  },
  SW: {
    operatorCode: "SW",
    country: "Namibia",
    label: {
      en: "Air Namibia - Reward$",
      ar: "طيران ناميبيا - ريوردز"
    }
  },
  NZ: {
    operatorCode: "NZ",
    country: "New Zealand",
    group: "Star Alliance",
    label: {
      en: "Air New Zealand - Airpoints",
      ar: "طيران نيوزيلندا - أير بوينتس"
    }
  },
  PX: {
    operatorCode: "PX",
    country: "Papua New Guinea",
    label: {
      en: "Air Niugini - Destinations",
      ar: "طيران نيوجيني - دستنيشينز"
    }
  },
  VT: {
    operatorCode: "VT",
    country: "French Polynesia",
    label: {
      en: "Air Tahiti - Kaveka",
      ar: "طيران تاهيتي - كافيكا"
    }
  },
  TN: {
    operatorCode: "TN",
    country: "French Polynesia",
    label: {
      en: "Air Tahiti Nui - Club Tiare",
      ar: "طيران تاهيتي نوي - كلوب تاير"
    }
  },
  AS: {
    operatorCode: "AS",
    country: "USA",
    label: {
      en: "Alaska Airlines - Mileage Plan",
      ar: "خطوط آلاسكا الجوية - مايليج بلان"
    }
  },
  AZ: {
    operatorCode: "AZ",
    country: "Italy",
    group: "SkyTeam",
    label: {
      en: "Alitalia - MilleMiglia",
      ar: "الخطوط الجوية الإيطالية - ميل مجليا"
    }
  },
  AA: {
    operatorCode: "AA",
    country: "USA",
    group: "Oneworld",
    label: {
      en: "American Airlines - AAdvantage",
      ar: "الخطوط الجوية الأمريكية - اي ادفانتيج"
    }
  },
  NH: {
    operatorCode: "NH",
    country: "Japan",
    label: {
      en: "All Nippon Airways - ANA Mileage Club",
      ar: "خطوط أول نيبون الجوية - أنا مايليج كلوب "
    }
  },
  W3: {
    operatorCode: "W3",
    country: "Nigeria",
    label: {
      en: "Arik Air - Affinity Wings",
      ar: "طيران أريك - أفنيتي وينجز"
    }
  },
  OZ: {
    operatorCode: "OZ",
    country: "South Korea",
    group: "Star Alliance",
    label: {
      en: "Asiana Airlines - Asiana Club",
      ar: "خطوط آسيانا الجوية - آسيانا كلوب"
    }
  },
  A2: {
    operatorCode: "A2",
    country: "Greece",
    label: {
      en: "Astra Airlines - Astra Miles",
      ar: "أسترا أير - أسترا مايلز"
    }
  },
  KK: {
    operatorCode: "KK",
    country: "Turkey",
    label: {
      en: "Atlas Global - Atlasmiles",
      ar: "أطلس جلوبال - أطلس مايلز"
    }
  },
  AV: {
    operatorCode: "AV",
    country: "Colombia/El Salvador",
    group: "Star Alliance",
    label: {
      en: "Avianca - LifeMiles",
      ar: "طيران أفيانكا - لايف مايلز"
    }
  },
  O6: {
    operatorCode: "O6",
    country: "Brazil",
    label: {
      en: "Avianca Brasil - Amigo",
      ar: "أفيانكا برازيل - اميجو"
    }
  },
  J2: {
    operatorCode: "J2",
    country: "Azerbaijan",
    label: {
      en: "Azerbaijan Airlines - Azal Miles",
      ar: "الخطوط الجوية الأذربيجانية - آزال مايلز"
    }
  },
  AD: {
    operatorCode: "AD",
    country: "Brazil",
    label: {
      en: "Azul Linhas Aereas - Tudo Azul",
      ar: " أزول لينهاس أيرياز - تودو أزول"
    }
  },
  UP: {
    operatorCode: "UP",
    country: "Bahamas",
    label: {
      en: "Bahamasair - Bahamasair Flyer",
      ar: "باهاماز إير - باهاماز فلاير"
    }
  },
  PG: {
    operatorCode: "PG",
    country: "Thailand",
    label: {
      en: "Bangkok Airways - FlyerBonus",
      ar: "طيران بانكوك ايرويز - فلاير بونص"
    }
  },
  ID: {
    operatorCode: "ID",
    country: "Indonesia",
    label: {
      en: "Batik Air - Batik Miles",
      ar: "باتيك إير - باتيك مايلز"
    }
  },
  B2: {
    operatorCode: "B2",
    country: "Belarus",
    label: {
      en: "Belavia - Belavia Leader",
      ar: "طيران بيلافيا - زعيم بيلافيا"
    }
  },
  B3: {
    operatorCode: "B3",
    country: "Bhutan",
    label: {
      en: "Bhutan Airlines - Tashi Miles",
      ar: "طيران بوتان - تاشي مايلز"
    }
  },
  BG: {
    operatorCode: "BG",
    country: "Bangladesh",
    label: {
      en: "Biman Bangladesh Airline - Biman Loyalty Club",
      ar: "خطوط بيمان بنغلاديش الجوية - بيمان لويالتي كلوب"
    }
  },
  NT: {
    operatorCode: "NT",
    country: "Spain",
    label: {
      en: "Binter Canarias - BinterMás",
      ar: "بينتر كانارياس - بينتر ماس"
    }
  },
  "0B": {
    operatorCode: "0B",
    country: "Romania",
    label: {
      en: "Blue Air - myBlue",
      ar: "بلو إير - ماي بلو"
    }
  },
  YB: {
    operatorCode: "YB",
    country: "Turkey",
    label: {
      en: "Borajet - Fly Borajet",
      ar: "بورا جيت للطيران - فلاي بورا جيت"
    }
  },
  BA: {
    operatorCode: "BA",
    country: "UK",
    group: "Oneworld",
    label: {
      en: "British Airways - Executive Club",
      ar: "الخطوط الجوية البريطانية - اكزيكاتيف كلوب "
    }
  },
  SN: {
    operatorCode: "SN",
    country: "Belgium",
    group: "Star Alliance",
    label: {
      en: "Brussels Airlines - LOOP",
      ar: "خطوط بروكسل الجوية - إل أو أو بي"
    }
  },
  U4: {
    operatorCode: "U4",
    country: "Nepal",
    label: {
      en: "Buddha Air - Royal Club",
      ar: "بوذا للطيران - رويال كلوب"
    }
  },
  FB: {
    operatorCode: "FB",
    country: "Bulgaria",
    label: {
      en: "Bulgaria Air - FLY MORE",
      ar: "طيران بلغاريا - فلاي مور"
    }
  },
  "5T": {
    operatorCode: "5T",
    country: "Canada",
    label: {
      en: "Canadian North - Aurora Rewards",
      ar: "كنيديان نورث - اورورا ريواردز"
    }
  },
  BW: {
    operatorCode: "BW",
    country: "Trinidad & Tobago",
    label: {
      en: "Caribbean Airlines - Caribbean Miles",
      ar: "الخطوط الجوية الكاريبية - كاريبيان مايلز"
    }
  },
  CX: {
    operatorCode: "CX",
    country: "PR China",
    group: "Oneworld",
    label: {
      en: "Cathay Pacific - Asia Miles",
      ar: "كاثاي باسيفيك - آسيا مايلز"
    }
  },
  KX: {
    operatorCode: "KX",
    country: "Cayman Islands",
    label: {
      en: "Cayman Airways - Sir Turtle Rewards",
      ar: "خطوط كايمان الجوية - سير ترتل ريواردز"
    }
  },
  "5J": {
    operatorCode: "5J",
    country: "Philippines",
    label: {
      en: "Cebu Pacific - GetGo",
      ar: "سيبو باسيفيك - جت جو"
    }
  },
  "5Z": {
    operatorCode: "5Z",
    country: "South Africa",
    label: {
      en: "CemAir - Skyrewards",
      ar: "سيم أير - سكاي ريواردز"
    }
  },
  CI: {
    operatorCode: "CI",
    country: "ROC-Taiwan",
    group: "SkyTeam",
    label: {
      en: "China Airlines - Dynasty Flyer",
      ar: "الخطوط الجوية الصينية - \tداينستي فلاير"
    }
  },
  MU: {
    operatorCode: "MU",
    country: "PR China",
    group: "SkyTeam",
    label: {
      en: "China Eastern - EasternMiles",
      ar: "خطوط شرق الصين الجوية - ايسترن مايلز"
    }
  },
  CZ: {
    operatorCode: "CZ",
    country: "PR China",
    group: "SkyTeam",
    label: {
      en: "China Southern Airlines - Sky Pearl Club",
      ar: "خطوط جنوب الصين الجوية - سكاي بيرل كلوب"
    }
  },
  CM: {
    operatorCode: "CM",
    country: "Panama",
    group: "Star Alliance",
    label: {
      en: "Copa Airlines - ConnectMiles",
      ar: "خطوط كوبا الجوية - كونكت مايلز"
    }
  },
  SS: {
    operatorCode: "SS",
    country: "France",
    label: {
      en: "Corsair International - Club Corsair",
      ar: "كورساير انترناشونال - كورساير كلوب"
    }
  },
  OK: {
    operatorCode: "OK",
    country: "Czech Republic",
    group: "SkyTeam",
    label: {
      en: "Czech Airlines - OK Plus",
      ar: "الخطوط الجوية التشيكية - \tأوكي بلاس"
    }
  },
  DL: {
    operatorCode: "DL",
    country: "USA",
    group: "SkyTeam",
    label: {
      en: "Delta Air Lines - SkyMiles",
      ar: "خطوط دلتا الجوية - \tسكاي مايلز"
    }
  },
  Z6: {
    operatorCode: "Z6",
    country: "Ukraine",
    label: {
      en: "Dniproavia - Bonus Club",
      ar: "خطوط دنيبرو آفيا  - بونص كلوب"
    }
  },
  MS: {
    operatorCode: "MS",
    country: "Egypt",
    group: "Star Alliance",
    label: {
      en: "Egyptair - EgyptAir Plus",
      ar: "مصر للطيران - مصر للطيران بلاس"
    }
  },
  EK: {
    operatorCode: "EK",
    country: "UAE",
    label: {
      en: "Emirates - Skywards",
      ar: "طيران الامارات - سكاي واردز"
    }
  },
  ET: {
    operatorCode: "ET",
    country: "Ethiopia",
    group: "Star Alliance",
    label: {
      en: "Ethiopian Airlines - ShebaMiles",
      ar: "الخطوط الجوية الإثيوبية - شيبا مايلز"
    }
  },
  EY: {
    operatorCode: "EY",
    country: "UAE",
    label: {
      en: "Etihad Airways - Etihad Guest",
      ar: "الاتحاد للطيران - ضيف الاتحاد"
    }
  },
  EW: {
    operatorCode: "EW",
    country: "Germany",
    label: {
      en: "Eurowings - Boomerang Club",
      ar: "أجنحة يورو - بوميرانغ كلوب"
    }
  },
  BR: {
    operatorCode: "BR",
    country: "ROC-Taiwan",
    group: "Star Alliance",
    label: {
      en: "EVA Air - Infinity MileageLands",
      ar: "إيفا للطيران - انفنتي مايلج لاندز"
    }
  },
  AY: {
    operatorCode: "AY",
    country: "Finland",
    group: "Oneworld",
    label: {
      en: "Finnair - Finnair Plus",
      ar: "فين إير - فين إير بلاس"
    }
  },
  FZ: {
    operatorCode: "FZ",
    country: "UAE",
    label: {
      en: "flydubai - Skywards",
      ar: "فلاي دبي - سكاي واردز"
    }
  },
  XY: {
    operatorCode: "XY",
    country: "Saudi Arabia",
    label: {
      en: "flynas - nasmiles",
      ar: "طيران ناس - ناسمايلز"
    }
  },
  F9: {
    operatorCode: "F9",
    country: "USA",
    label: {
      en: "Frontier - EarlyReturns",
      ar: "خطوط فرونتير الجوية - ايرلي ريترنز"
    }
  },
  GA: {
    operatorCode: "GA",
    country: "Indonesia",
    group: "SkyTeam",
    label: {
      en: "Garuda - GarudaMiles",
      ar: "طيران جارودا - جارودا مايلز"
    }
  },
  G3: {
    operatorCode: "G3",
    country: "Brazil",
    label: {
      en: "Gol - Smiles",
      ar: "طيران جول - سمايلز"
    }
  },
  GF: {
    operatorCode: "GF",
    country: "Bahrain",
    label: {
      en: "Gulf Air - Falconflyer",
      ar: "طيران الخليج - فالكون فلاير"
    }
  },
  HU: {
    operatorCode: "HU",
    country: "PR China",
    label: {
      en: "Hainan Airlines - Fortune Wings Club",
      ar: "خطوط هاينان الجوية  - فورتشن وينجز كلوب"
    }
  },
  HA: {
    operatorCode: "HA",
    country: "USA",
    label: {
      en: "Hawaiian Airlines - Hawaiian Miles",
      ar: "خطوط هاواي الجوية - هاواي مايلز"
    }
  },
  IB: {
    operatorCode: "IB",
    country: "Spain",
    group: "Oneworld",
    label: {
      en: "Iberia - Iberia Plus",
      ar: "الخطوط الجوية الأيبيرية - أيبيريا بلاس"
    }
  },
  FI: {
    operatorCode: "FI",
    country: "Iceland",
    label: {
      en: "Icelandair - Saga Club",
      ar: "أير آيسلاند - سيجا كلوب"
    }
  },
  "7I": {
    operatorCode: "7I",
    country: "Netherlands Antilles",
    label: {
      en: "Insel Air - Insel StarMiles",
      ar: "انسيل أير - انسيل ستار مايلز"
    }
  },
  "4O": {
    operatorCode: "4O",
    country: "Mexico",
    label: {
      en: "Interjet - Club Interjet Premium",
      ar: "انتر جت - كلوب انتر جت بريميوم"
    }
  },
  IR: {
    operatorCode: "IR",
    country: "Iran",
    label: {
      en: "Iran Air - SkyGift",
      ar: "إيران للطيران -  سكاي جيفت"
    }
  },
  JL: {
    operatorCode: "JL",
    country: "Japan",
    group: "Oneworld",
    label: {
      en: "Japan Airlines - JAL Mileage Bank",
      ar: "الخطوط الجوية اليابانية - \tبنك أميال جال"
    }
  },
  J9: {
    operatorCode: "J9",
    country: "Kuwait",
    label: {
      en: "Jazeera Airways - Jazeerati",
      ar: "طيران الجزيرة - جزيرتي"
    }
  },
  "7C": {
    operatorCode: "7C",
    country: "South Korea",
    label: {
      en: "Jeju Air - Refresh Point",
      ar: "جيجو اير - ريفريش بوينت"
    }
  },
  "9W": {
    operatorCode: "9W",
    country: "India",
    label: {
      en: "Jet Airways - JetPrivilege",
      ar: "الخطوط الجوية جيت - جيت بريفيليج"
    }
  },
  B6: {
    operatorCode: "B6",
    country: "USA",
    label: {
      en: "jetBlue - TrueBlue",
      ar: "خطوط جيت بلو الجوية - ترو بلو"
    }
  },
  HO: {
    operatorCode: "HO",
    country: "PR China",
    label: {
      en: "Juneyao Airlines - Juneyao Club",
      ar: "جونياو ايرلاينز - جونياو كلوب"
    }
  },
  KE: {
    operatorCode: "KE",
    country: "South Korea",
    group: "SkyTeam",
    label: {
      en: "Korean Air - Skypass",
      ar: "كوريا للطيران - سكاي باس"
    }
  },
  KU: {
    operatorCode: "KU",
    country: "Kuwait",
    label: {
      en: "Kuwait Airways - Oasis Club",
      ar: "الخطوط الجوية الكويتية - نادي الواحة"
    }
  },
  B0: {
    operatorCode: "B0",
    country: "France",
    label: {
      en: "La Compagnie - MyCompagnie",
      ar: "طيران لا كومبانيه - ماي كومبانيه"
    }
  },
  TM: {
    operatorCode: "TM",
    country: "Mozambique",
    label: {
      en: "LAM - Flamingo Club",
      ar: " لام ايرلاينز - فلامنجو كلوب"
    }
  },
  JT: {
    operatorCode: "JT",
    country: "Indonesia",
    label: {
      en: "Lion Air - Passport Club",
      ar: "ليون إير - باسبورت كلوب"
    }
  },
  LH: {
    operatorCode: "LH",
    country: "Germany",
    group: "Star Alliance",
    label: {
      en: "Lufthansa - Miles & More",
      ar: "لوفتهانزا - مايلز آند مور"
    }
  },
  W5: {
    operatorCode: "W5",
    country: "Iran",
    label: {
      en: "Mahan Air - Mahan & Miles",
      ar: "ماهان إير - ماهان آند مايلز"
    }
  },
  MH: {
    operatorCode: "MH",
    country: "Malaysia",
    group: "Oneworld",
    label: {
      en: "Malaysia Airlines - Enrich",
      ar: "الخطوط الجوية الماليزية - إنريتش"
    }
  },
  OD: {
    operatorCode: "OD",
    country: "Malaysia",
    label: {
      en: "Malindo Air - Malindo Miles",
      ar: "طيران ماليندو - ماليندو مايلز"
    }
  },
  ME: {
    operatorCode: "ME",
    country: "Lebanon",
    group: "SkyTeam",
    label: {
      en: "Middle East Airlines - Cedar Miles",
      ar: "طيران الشرق الأوسط - سيدر مايلز"
    }
  },
  IG: {
    operatorCode: "IG",
    country: "Italy",
    label: {
      en: "Meridiana - Meridiana Club",
      ar: "طيران ميرديانا - ميرديانا كلوب"
    }
  },
  ZB: {
    operatorCode: "ZB",
    country: "UK",
    label: {
      en: "Monarch Airlines - Vantage Club",
      ar: "خطوط مونارك الجوية - فانتاج كلوب"
    }
  },
  YM: {
    operatorCode: "YM",
    country: "Montenegro",
    label: {
      en: "Montenegro Airlines - Vision Team",
      ar: "طيران مونتينيغرو - فيجن تيم"
    }
  },
  "8M": {
    operatorCode: "8M",
    country: "Myanmar",
    label: {
      en: "Myanmar Airways - Sky Smile Club",
      ar: "خطوط ميانمار الجوية - سكاي سمايل كلوب"
    }
  },
  "5N": {
    operatorCode: "5N",
    country: "Russia",
    label: {
      en: "Nordavia - Golden Mile",
      ar: "طيران نوردافيا - جولدن مايل"
    }
  },
  D8: {
    operatorCode: "D8",
    country: "Norway",
    label: {
      en: "Norwegian - Norwegian Reward",
      ar: "الخطوط النرويجية - نرويجيان ريوورد "
    }
  },
  VQ: {
    operatorCode: "VQ",
    country: "Bangladesh",
    label: {
      en: "Novoair - Smiles",
      ar: "طيران نوفو إير - سمايلز"
    }
  },
  WY: {
    operatorCode: "WY",
    country: "Oman",
    label: {
      en: "Oman Air - Sindbad",
      ar: "الطيران العماني - السندباد"
    }
  },
  "8Q": {
    operatorCode: "8Q",
    country: "Turkey",
    label: {
      en: "Onur Air - Onur Extra",
      ar: "طيران اونور - اونور اكسترا"
    }
  },
  PC: {
    operatorCode: "PC",
    country: "Turkey",
    label: {
      en: "Pegasus Airlines - Pegasus Plus",
      ar: "خطوط بيغاسوس الجوية - بيغاسوس بلاس"
    }
  },
  YP: {
    operatorCode: "YP",
    country: "Canada",
    label: {
      en: "Perimeter Aviation - Frequent Flyer Program",
      ar: " بيريميتر افيايشن - برنامج المسافر الدائم"
    }
  },
  P9: {
    operatorCode: "P9",
    country: "Peru",
    label: {
      en: "Peruvian Airlines - Peruvian Pass",
      ar: "الخطوط الجوية البيروفية - بيروفيان باس"
    }
  },
  PR: {
    operatorCode: "PR",
    country: "Philippines",
    label: {
      en: "Philippine Airlines - Mabuhay Miles",
      ar: "الخطوط الجوية الفلبينية - مابوهاي مايلز"
    }
  },
  PK: {
    operatorCode: "PK",
    country: "Pakistan",
    label: {
      en: "PIA - Awards + Plus",
      ar: "الخطوط الجوية الدولية الباكستانية - اواردز + بلاس"
    }
  },
  PD: {
    operatorCode: "PD",
    country: "Canada",
    label: {
      en: "Porter Airlines - VIPorter",
      ar: "بورتر ايرلاينز - في آي بورتر"
    }
  },
  PW: {
    operatorCode: "PW",
    country: "Tanzania",
    label: {
      en: "Precision Air - PAA Royal",
      ar: "بريسيشن إير - بي آي آي رويال"
    }
  },
  QF: {
    operatorCode: "QF",
    country: "Australia",
    group: "Oneworld",
    label: {
      en: "Qantas - Frequent Flyer",
      ar: "خطوط كانتس الجوية - المسافر الدائم"
    }
  },
  QR: {
    operatorCode: "QR",
    country: "Qatar",
    group: "Oneworld",
    label: {
      en: "Qatar Airways - Privilege Club",
      ar: "الخطوط الجوية القطرية - نادي الامتياز"
    }
  },
  "7H": {
    operatorCode: "7H",
    country: "USA",
    label: {
      en: "Ravn Alaska - FlyAway Rewards",
      ar: "طيران رافن ألاسكا - فلاي اويه ريواردز"
    }
  },
  AT: {
    operatorCode: "AT",
    country: "Morocco",
    label: {
      en: "Royal Air Maroc - Safar Flyer",
      ar: "الخطوط الملكية المغربية - سفر فلاير"
    }
  },
  BI: {
    operatorCode: "BI",
    country: "Brunei",
    label: {
      en: "Royal Brunei Airlines - Royal Skies",
      ar: "خطوط رويال بروناي الجوية - رويال سكايز"
    }
  },
  RJ: {
    operatorCode: "RJ",
    country: "Jordan",
    group: "Oneworld",
    label: {
      en: "Royal Jordanian - Royal Plus",
      ar: "الملكية الأردنية - رويال بلاس "
    }
  },
  WB: {
    operatorCode: "WB",
    country: "Rwanda",
    label: {
      en: "RwandAir - Dream Miles",
      ar: "طيران رواند - دريم مايلز"
    }
  },
  S7: {
    operatorCode: "S7",
    country: "Russia",
    group: "Oneworld",
    label: {
      en: "S7 Airlines - S7 Priority",
      ar: "خطوط إس سيفين - إس سيفين بريوريتي"
    }
  },
  "4Q": {
    operatorCode: "4Q",
    country: "Afghanistan",
    label: {
      en: "Safi Airways - Saffron Rewards",
      ar: "الخطوط الجوية الصافي - سافرون ريواردز"
    }
  },
  SK: {
    operatorCode: "SK",
    country: "Sweden/Denmark/Norway",
    label: {
      en: "SAS - EuroBonus",
      ar: "الخطوط الجوية الإسكندنافية -يورو بونص"
    }
  },
  SV: {
    operatorCode: "SV",
    country: "Saudi Arabia",
    group: "SkyTeam",
    label: {
      en: "Saudia - Alfursan",
      ar: "الخطوط الجوية السعودية - الفرسان"
    }
  },
  "6S": {
    operatorCode: "6S",
    country: "Saudi Arabia",
    label: {
      en: "SaudiGulf - SaudiGulf Club",
      ar: "طيران السعودية الخليجية - نادي السعودية الخليجية"
    }
  },
  "3U": {
    operatorCode: "3U",
    country: "PR China",
    label: {
      en: "Sichuan Airlines - Golden Panda",
      ar: "خطوط سيشوان الجويه - جولدن باندا"
    }
  },
  SQ: {
    operatorCode: "SQ",
    country: "Singapore",
    group: "Star Alliance",
    label: {
      en: "Singapore Airlines - KrisFlyer",
      ar: "الخطوط الجوية السنغافورية - كريس فلاير"
    }
  },
  SA: {
    operatorCode: "SA",
    country: "South Africa",
    group: "Star Alliance",
    label: {
      en: "South African Airways - Voyager",
      ar: "خطوط جنوب أفريقيا الجوية - فوياجر"
    }
  },
  WN: {
    operatorCode: "WN",
    country: "USA",
    label: {
      en: "Southwest Airlines - Rapid Rewards",
      ar: "خطوط ساوث ويست الجوية -  رابيد ريواردز"
    }
  },
  SG: {
    operatorCode: "SG",
    country: "India",
    label: {
      en: "SpiceJet - SpiceClub",
      ar: "سبايس جت - سبايس كلوب"
    }
  },
  NK: {
    operatorCode: "NK",
    country: "USA",
    label: {
      en: "Spirit Airlines - Free Spirit",
      ar: "خطوط سبيريت الجوية - فري سبيريت"
    }
  },
  "9C": {
    operatorCode: "9C",
    country: "PR China",
    label: {
      en: "Spring Airlines - SpringPass",
      ar: "سبرنج ايرلاينز - سبرنج باس"
    }
  },
  UL: {
    operatorCode: "UL",
    country: "Sri Lanka",
    group: "Oneworld",
    label: {
      en: "SriLankan Airlines - FlySmiLes",
      ar: "الخطوط الجوية السريلانكية - فلاي سمايلز"
    }
  },
  "XQ*": {
    operatorCode: "XQ*",
    country: "Turkey",
    label: {
      en: "SunExpress - SunPoints",
      ar: "طيران صن اكسبريس - صن بوينتس"
    }
  },
  PY: {
    operatorCode: "PY",
    country: "Surinam",
    label: {
      en: "Surinam Airways - Loyal Wings",
      ar: "خطوط سورينام الجوية - لويال وينجز"
    }
  },
  RB: {
    operatorCode: "RB",
    country: "Syria",
    label: {
      en: "Syrian Air - Frequent Flyer",
      ar: "الخطوط الجوية السورية - المسافر الدائم"
    }
  },
  DT: {
    operatorCode: "DT",
    country: "Angola",
    label: {
      en: "TAAG - Umbi Umbi Club"
    }
  },
  EQ: {
    operatorCode: "EQ",
    country: "Ecuador",
    label: {
      en: "Tame - Tame Millas"
    }
  },
  TP: {
    operatorCode: "TP",
    country: "Portugal",
    group: "Star Alliance",
    label: {
      en: "TAP Portugal - Victoria",
      ar: "طيران تاب البرتغال - تاب فكتوريا"
    }
  },
  TG: {
    operatorCode: "TG",
    country: "Thailand",
    group: "Star Alliance",
    label: {
      en: "Thai Airways - Royal Orchid Plus",
      ar: "الخطوط الجوية الدولية التايلاندية - رويال بلاس أوركيد"
    }
  },
  TK: {
    operatorCode: "TK",
    country: "Turkey",
    group: "Star Alliance",
    label: {
      en: "Turkish Airlines - Miles&Smiles",
      ar: "الخطوط الجوية التركية - مايلز آند سمايلز"
    }
  },
  Q8: {
    operatorCode: "Q8",
    country: "Congo (Republic)",
    label: {
      en: "Trans Air Congo - Miles Plus",
      ar: "طيران ترانس كونغو - مايلز بلاس"
    }
  },
  TU: {
    operatorCode: "TU",
    country: "Tunisia",
    label: {
      en: "Tunisair - Fidelys",
      ar: "الخطوط التونسية - فيدليس"
    }
  },
  PS: {
    operatorCode: "PS",
    country: "Ukraine",
    label: {
      en: "Ukraine International Airlines - Panorama Club",
      ar: "الخطوط الجوية الأوكرانية - بانوراما كلوب"
    }
  },
  UA: {
    operatorCode: "UA",
    country: "USA",
    group: "Star Alliance",
    label: {
      en: "United Airlines - Mileage Plus",
      ar: "الخطوط الجوية المتحدة - ميليج بلاس"
    }
  },
  U6: {
    operatorCode: "U6",
    country: "Russia",
    label: {
      en: "Ural Airlines - Wings",
      ar: "طيران اورال - وينجز"
    }
  },
  BS: {
    operatorCode: "BS",
    country: "Bangladesh",
    label: {
      en: "Bangla Airlines - Sky Star",
      ar: "الخطوط الجوية البنغالية - سكاي ستار"
    }
  },
  QU: {
    operatorCode: "QU",
    country: "Russia",
    label: {
      en: "UTair - Status",
      ar: "الخطوط الجوية اوتير - ستاتوس"
    }
  },
  HY: {
    operatorCode: "HY",
    country: "Uzbekistan",
    label: {
      en: "Uzbekistan Airways - Uz Air Plus",
      ar: "الخطوط الجوية الأوزبكستانية - أوز أير بلاس"
    }
  },
  VN: {
    operatorCode: "VN",
    country: "Vietnam",
    group: "SkyTeam",
    label: {
      en: "Vietnam Airlines - Lotusmiles",
      ar: "الخطوط الجوية الفيتنامية - لوتس مايلز"
    }
  },
  VX: {
    operatorCode: "VX",
    country: "USA",
    label: {
      en: "Virgin America - Elevate",
      ar: "فيرجن أمريكا - ايليفيت"
    }
  },
  VS: {
    operatorCode: "VS",
    country: "UK",
    label: {
      en: "Virgin Atlantic - Flying Club",
      ar: "خطوط فيرجن أتلانتيك الجوية - فلاينج كلوب"
    }
  },
  VA: {
    operatorCode: "VA",
    country: "Australia",
    label: {
      en: "Virgin Australia - Velocity",
      ar: "خطوط فيرجن أستراليا الجوية - فيلوسيتي"
    }
  },
  UK: {
    operatorCode: "UK",
    country: "India",
    label: {
      en: "Vistara - Club Vistara",
      ar: "فيستارا - كلوب فيستارا"
    }
  },
  VY: {
    operatorCode: "VY",
    country: "Spain",
    label: {
      en: "Vueling - Punto"
    }
  },
  WS: {
    operatorCode: "WS",
    country: "Canada",
    label: {
      en: "WestJet - WestJet Rewards",
      ar: "خطوط فيولينغ الجوية - بونتو"
    }
  },
  MF: {
    operatorCode: "MF",
    country: "PR China",
    group: "SkyTeam",
    label: {
      en: "Xiamen Airlines - Egret Club",
      ar: "خطوط زيامن الجوية - اجريت كلوب"
    }
  },
  R3: {
    operatorCode: "R3",
    country: "Russia",
    label: {
      en: "Yakutia - Free Flight",
      ar: "خطوط ياقوتة الجوية - فري فلايت"
    }
  },
  YH: {
    operatorCode: "YH",
    country: "Myanmar",
    label: {
      en: "Yangon Airways - Elite Club",
      ar: "يانغون ايرويز - كلوب ايليت"
    }
  },
  IY: {
    operatorCode: "IY",
    country: "Yemen",
    label: {
      en: "Yemenia - Sama Club",
      ar: "الخطوط الجوية اليمنية - نادي سما"
    }
  },
  LX: {
    operatorCode: "LX",
    country: "Switzerland",
    group: "Star Alliance",
    label: {
      en: "SWISS Airlines - Miles & More",
      ar: "سويسرا للطيران - مايلز آند مور"
    }
  }
};
var FARE_RULES_STATUS_MAP = exports.FARE_RULES_STATUS_MAP = {
  MINI_FARE_RULES: 2,
  TEXT_FARE_RULES: 1,
  NO_FARE_RULES: 0,
  ALLOWED: "ALLOWED",
  NOT_ALLOWED: "NOT_ALLOWED",
  NOT_AVAILABLE: "NOT_AVAILABLE"
};
var REFUND_METHODS = exports.REFUND_METHODS = {
  CREDIT_SHELL: "credit_shell",
  Direct_TO_AIRLINE: "internal_refund",
  INTERNAL_REFUND: "direct_to_airline"
};
var FARE_RULES_TYPE_MAP = exports.FARE_RULES_TYPE_MAP = {
  MINI_FARE_RULES: "mini_fare_rules",
  FULL_TEXT: "full_text_fare_rules",
  NO_FARE_RULES: "no_fare_rules_found"
};
var COVID_SHEET_NAMES = exports.COVID_SHEET_NAMES = {
  COUNTRY: "Country_SRP",
  AIRLINE: "Airlines_FlightDetails",
  PAX: "Traveller_PAX",
  LAST_UPDATED: "lastupdated"
};
var FLIGHT_SEARCH_META = exports.FLIGHT_SEARCH_META = {
  title: {
    en: "Book Cheap flights from {origin} to {destination}, Save more with {brand}",
    ar: "احجز رحلات طیران رخیصة من {origin} الي {destination}، ووفر أكثر مع {brand}"
  },
  description: {
    en: "Book {origin} to {destination} Flights with {brand}. Compare and find the best flights at the cheapest rates. Have a comfortable flight with us. Book now!",
    ar: "احجز رحلات طیران من {origin} الي {destination}، قارن واعثر على أفضل الرحلات بأرخص الأسعار. أحصل على رحلة مریحة معنا. احجز الآن!"
  }
};
var SEARCH_BOX_STATE_PROPS = exports.SEARCH_BOX_STATE_PROPS = ["searchType", "legs", "cabin", "infants", "children", "adults", "nonstop", "flexibleDate"];
var SEARCH_BOX_CONSTANTS = exports.SEARCH_BOX_CONSTANTS = {
  DEFAULT_CABIN: "Economy",
  MIN_PAX_COUNT: 1,
  MAX_PAX_COUNT: 9,
  MIN_ADULTS_COUNT: 1,
  MIN_CHILDREN_COUNT: 0,
  MIN_INFANTS_COUNT: 0,
  NON_STOP: false,
  NEAR_BY_ORIGIN: false,
  NEAR_BY_DESTINATION: false,
  DEPARTURE_DATE_OFFSET_DAYS: 1,
  RETURN_DATE_OFFSET_DAYS: 2,
  TRIP_DURATION_DAYS: 1,
  MAX_TRIP_DURATION_MONTHS: 12,
  MIN_LEGS_COUNT: 1,
  MAX_LEGS_COUNT: 6,
  REQUEST_DATE_FORMAT: "YYYY-MM-DD",
  FROM_DATE: "FROM_DATE",
  TO_DATE: "TO_DATE",
  INVALID_DATE: "Invalid date",
  FLIGHTS_RECENT_QUERIES: "FLIGHTS_RECENT_QUERIES",
  MAX_SAVED_QUERY_NUMBER: 3,
  FLEX_1D: "flex-1d"
};
var SEARCH_BOX_ERRORS = exports.SEARCH_BOX_ERRORS = {
  EMPTY_ORIGIN: "emptyOrigin",
  EMPTY_DESTINATION: "emptyDestination",
  NO_RESULT_ORIGIN: "noResultOrigin",
  NO_RESULT_DESTINATION: "noResultDestination",
  SAME_OND: "sameOND",
  EMPTY_DEPARTURE_DATE: "emptyDepartureDate",
  EMPTY_RETURN_DATE: "emptyReturnDate",
  DEPARTURE_GREATER: "departureGreater",
  GENERAL: "general",
  MULTI_CITY_LEG_DEPARTURE_GREATER: "multiCityLegDepartureGreater"
};
var AIRLINES_WITH_COVERAGE = exports.AIRLINES_WITH_COVERAGE = ["EK", "EY", "FZ", "G9", "WY"];
var FLYNAS_CODE = exports.FLYNAS_CODE = "XY";
var FLYADEAL_CODE = exports.FLYADEAL_CODE = "F3";
var DEFAULT_BAGGAGE_QUANTITY = exports.DEFAULT_BAGGAGE_QUANTITY = 1;
var DEFAULT_BAGGAGE_WEIGHT = exports.DEFAULT_BAGGAGE_WEIGHT = 20;
var DEFAULT_BAGGAGE_WEIGHT_SV = exports.DEFAULT_BAGGAGE_WEIGHT_SV = 23;
var TOP_PICKS_VALUES = exports.TOP_PICKS_VALUES = {
  A: "a",
  B: "b",
  C: "c"
};
var TOP_PICKS_POPULAR_FLIGTHS_CODES = exports.TOP_PICKS_POPULAR_FLIGTHS_CODES = ["XY-17", "XY-22", "NP-1128", "XY-265", "XY-415", "XY-84", "XY-81", "F3-4760", "F3-4783", "XY-566"];
var TOP_PICKS_POPULAR_FLIGTHS = exports.TOP_PICKS_POPULAR_FLIGTHS = {
  "RUH-JED": {
    Monday: ["XY-03"],
    Tuesday: ["XY-03"],
    Wednesday: ["XY-03"],
    Thursday: ["XY-03"],
    Friday: ["XY-59"],
    Saturday: ["XY-03"],
    Sunday: ["XY-03"]
  },
  "JED-RUH": {
    Monday: ["XY-14"],
    Tuesday: ["XY-14"],
    Wednesday: ["XY-14"],
    Thursday: ["XY-54"],
    Friday: ["XY-18"],
    Saturday: ["XY-18"],
    Sunday: ["F3-4691"]
  },
  "JED-CAI": {
    Monday: ["E5-1326"],
    Wednesday: ["E5-1326"],
    Thursday: ["NP-1128"],
    Friday: ["NP-1128"],
    Saturday: ["NP-1128"],
    Sunday: ["NP-1128"]
  },
  "RUH-CAI": {
    Monday: ["XY-263"],
    Tuesday: ["NP-1152"],
    Wednesday: ["XY-263"],
    Thursday: ["NP-1152"],
    Friday: ["XY-263"],
    Saturday: ["NP-1152"],
    Sunday: ["XY-263"]
  },
  "DMM-JED": {
    Monday: ["XY-407"],
    Tuesday: ["XY-407"],
    Wednesday: ["XY-407"],
    Thursday: ["XY-403"],
    Friday: ["XY-407"],
    Saturday: ["XY-403"],
    Sunday: ["XY-403"]
  },
  "RUH-DXB": {
    Monday: ["XY-213"],
    Tuesday: ["F3-503"],
    Wednesday: ["XY-201"],
    Thursday: ["XY-201"],
    Friday: ["XY-215"],
    Saturday: ["XY-201"],
    Sunday: ["F3-503"]
  },
  "RUH-AHB": {
    Monday: ["F3-25"],
    Tuesday: ["F3-25"],
    Wednesday: ["F3-25"],
    Thursday: ["XY-89"],
    Friday: ["XY-81"],
    Saturday: ["F3-27"],
    Sunday: ["F3-27"]
  },
  "AHB-RUH": {
    Monday: ["XY-90"],
    Tuesday: ["XY-90"],
    Wednesday: ["F3-26"],
    Thursday: ["XY-90"],
    Friday: ["F3-26"],
    Saturday: ["F3-26"],
    Sunday: ["F3-20"]
  },
  "JED-DMM": {
    Monday: ["F3-4711"],
    Tuesday: ["F3-4711"],
    Wednesday: ["F3-4711"],
    Thursday: ["F3-4711"],
    Friday: ["F3-4711"],
    Saturday: ["F3-4711"],
    Sunday: ["F3-4711"]
  },
  "RUH-DMM": {
    Monday: ["F3-4778"],
    Tuesday: ["F3-4778"],
    Wednesday: ["F3-4778"],
    Thursday: ["F3-4778"],
    Friday: ["F3-4778"],
    Saturday: ["F3-4778"],
    Sunday: ["F3-4778"]
  }
};
var UNACCOMPANIED_MINOR_AIRLINES = exports.UNACCOMPANIED_MINOR_AIRLINES = [FLYNAS_CODE];
var FLEX_AIRLINES = exports.FLEX_AIRLINES = ["XY", "F3", "6E", "FZ", "SV", "QR", "EK", "MS", "TK", "LH", "GF"];
var CREDIT_SHELL_AIRLINES = exports.CREDIT_SHELL_AIRLINES = ["XY", "G9", "E5", "3L", "3O", "J9", "5J"];
var TOP_AIRLINES = exports.TOP_AIRLINES = ["SV", "XY", "F3", "MS", "NP", "E5", "J9", "SM", "6E", "G9"];
var PERPIECEWEIGHTFLAG = exports.PERPIECEWEIGHTFLAG = {
  FIRST: "FIRST",
  AVERAGE: "AVERAGE",
  SPLIT: "SPLIT"
};
var SERVICE_FEE_RULES_PATTERNS = exports.SERVICE_FEE_RULES_PATTERNS = [/^.*_upfront$/i];
var WORLD_CUP_FAN_ID = exports.WORLD_CUP_FAN_ID = {
  AIRPORTS: ["DOH", "DIA"],
  RANGE: ["2022-11-19", "2022-12-18"]
};
var ADDON_MERGE_ALL = exports.ADDON_MERGE_ALL = "MERGE_ALL";
var ONLINECHECKIN = exports.ONLINECHECKIN = {
  PREFIX: "online_checkin_",
  REGEX: "ONLINE_CHECKIN",
  DESCRIPTION: "MERGE CHECKIN"
};
var CFAR = exports.CFAR = {
  PREFIX: "CFAR_",
  REGEX: "^CFAR$",
  DESCRIPTION: "CFAR"
};
var CFAR_ONLINE_CHECKIN = exports.CFAR_ONLINE_CHECKIN = {
  PREFIX: "cfar_online_checkin_",
  REGEX: "^CFAR_ONLINE_CHECKIN$",
  DESCRIPTION: "CFAR ONLINE CHECKIN"
};
var INSURANCE = exports.INSURANCE = {
  PREFIX: "insurance_",
  REGEX: "INSURANCE",
  DESCRIPTION: "INSURANCE",
  TNC_JSON: "travel-insurance-content"
};
var ADDONS = exports.ADDONS = {
  ONLINECHECKIN: "autocheckin",
  CFAR: "cancellationfreedom",
  HASSLE_FREE: "hasslefreepackage",
  INSURANCE: "tripinsurance"
};
var ADDON_TNC_MAP = exports.ADDON_TNC_MAP = (_ADDON_TNC_MAP = {}, _ADDON_TNC_MAP[ADDONS.CFAR] = "cfar-tc", _ADDON_TNC_MAP[ADDONS.HASSLE_FREE] = "cfar-tc", _ADDON_TNC_MAP[ADDONS.INSURANCE] = "travel-insurance-content", _ADDON_TNC_MAP);
var ACTION_TYPES = exports.ACTION_TYPES = {
  CREATE_CART: "CREATE_CART",
  FETCH_CART: "FETCH_CART",
  UPDATE_CART: "UPDATE_CART",
  UPDATE_FLIGHT_SSR: "UPDATE_FLIGHT_SSR",
  CREATE_SALE: "CREATE_SALE",
  FETCH_SALE: "FETCH_SALE",
  UPDATE_SALE: "UPDATE_SALE",
  APPLY_ADD_ON: "APPLY_ADD_ON",
  REMOVE_ADD_ON: "REMOVE_ADD_ON"
};
var ADDONS_CONFIG = exports.ADDONS_CONFIG = {
  ONLINECHECKIN: ONLINECHECKIN,
  CFAR: CFAR,
  CFAR_ONLINE_CHECKIN: CFAR_ONLINE_CHECKIN,
  INSURANCE: INSURANCE
};
var CMS_PLATFORMS = exports.CMS_PLATFORMS = {
  DESKTOP: "web",
  MWEB: "mweb"
};
var OPEN_TICKETING_TYPES = exports.OPEN_TICKETING_TYPES = ["OpenTicket", "OpenReturnTicket"];
var ADDON_UI_TYPE = exports.ADDON_UI_TYPE = {
  ORIGINAL: "original",
  MULTIPLE: "multiple"
};
var ADDON_PLACEMENT = exports.ADDON_PLACEMENT = {
  TRAVELLERS: "travellers",
  ADDONS: "addons"
};
var DURATION_UNIT = exports.DURATION_UNIT = {
  DAY: "day",
  HOUR: "hour"
};
var ADDON_CURRENCY_ROUNDUP = exports.ADDON_CURRENCY_ROUNDUP = ["SAR", "QAR", "AED"];
var MULTI_REWARDS_ITEMS = exports.MULTI_REWARDS_ITEMS = ["item-0", "item-1"];
var AD_SOLUTION_PATH = exports.AD_SOLUTION_PATH = {
  APP: "/internal/flights",
  APP_PROXY_PATH: "/internal/flights" + _constants.HOSTS.AD_SOLUTION.PATHNAME
};
var NEXUS_SESSION_ID_HEADER = exports.NEXUS_SESSION_ID_HEADER = "x-nexus-session-id";